import jwt from "jsonwebtoken";

class TokenUtil {
  static encode(payload) {
    return jwt.sign(payload, process.env.REACT_APP_JWT_SECRET, {
      noTimestamp: true,
    });
  }

  static verify(token) {
    return jwt.verify(token, process.env.REACT_APP_JWT_SECRET, function (
      err,
      decoded
    ) {
      if (err) {
        throw err;
      }
      return decoded;
    });
  }

  static decode(token) {
    return jwt.decode(token);
  }
}

export default TokenUtil;
